import GuestOrdersScreen from "@/screens/GuestOrdersScreen";

export default GuestOrdersScreen;
